import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./PioneersSection.css";

import bgImage from "../../assets/Institute/jn-class.jpeg";
import overlay1 from "../../assets/Institute/DSC_1000.JPG";
import overlay2 from "../../assets/Institute/DSC_1010.JPG";
import overlay3 from "../../assets/Institute/DSC_0635.JPG";

const PioneersSection = () => {
  const [count, setCount] = useState({ teachers: 0, schools: 0, years: 0 });

  useEffect(() => {
    let start = 0;
    const interval = setInterval(() => {
      start++;
      if (start <= 5500)
        setCount({
          teachers: start,
          schools: Math.floor(start / 20),
          years: Math.floor(start / 275),
        });
      else clearInterval(interval);
    }, 1);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="pioneers-revamp"
      id="pioneers"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay"></div>

      <div className="pioneers-content">
        <motion.div
          className="pioneers-text"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2>
            Pioneers in <span>Early Childhood Education</span>
          </h2>

          <p>
            The <b>National Institute of Early Child Care & Education (NIECCE)</b> is a
            premier teacher training institute offering world-class education
            for aspiring <b>Nursery, Montessori, and Primary teachers</b>.
            Founded in <strong>2004</strong>, NIECCE has become one of India’s
            fastest-growing teacher training centers known for academic
            excellence and modern pedagogy.
          </p>

          <p>
            Recognized for its commitment to educational quality, NIECCE has
            received numerous awards such as <em>“Vidhyasree Rathna”</em>,{" "}
            <em>“Best Educationist”</em>, and <em>“Best Early Childhood Educator”</em> — a
            true testament to our team’s dedication to shaping exceptional
            educators.
          </p>

          <p>
            Over <strong>5500+ teachers</strong> have graduated through NIECCE’s
            holistic training modules combining theory, practical learning, and
            modern classroom exposure. With partnerships across{" "}
            <strong>leading schools</strong> and an active <b>placement cell</b>,
            NIECCE ensures that every graduate is career-ready.
          </p>

          <p>
            Our focus extends beyond academics — we aim to nurture
            <em> creativity, empathy, and leadership</em> in every teacher,
            empowering them to build strong educational foundations for young
            learners. Our curriculum is preferred by <b>CBSE, ICSE,
            International,</b> and <b>State board</b> schools across India.
          </p>

          <p>
            Another proud initiative under NIECCE is{" "}
            <strong>Little Kidz Preschool</strong>, a chain with over{" "}
            <strong>17 centers nationwide</strong>, providing high-quality early
            education to <strong>15,000+ children</strong>.
          </p>

          <p className="highlight">
            Simply put — NIECCE is <b>India’s pioneer in Early Child Care Education</b>,
            setting the benchmark for teacher training excellence.
          </p>

          <div className="stats">
            <div>
              <h3>{count.years}+</h3>
              <p>Years of Excellence</p>
            </div>
            <div>
              <h3>{count.teachers}+</h3>
              <p>Teachers Trained</p>
            </div>
            <div>
              <h3>{count.schools}+</h3>
              <p>Partner Schools</p>
            </div>
          </div>

          <a href="/course/admission" className="enquiry-btn">
            Admission Enquiry →
          </a>
        </motion.div>

        <motion.div
          className="floating-images"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
        >
          <img
            src={overlay1}
            alt="NIECCE teacher training session"
            title="NIECCE teacher training session"
            className="float-img img1"
          />
          <img
            src={overlay2}
            alt="NIECCE teacher training graduates"
            title="NIECCE teacher training graduates"
            className="float-img img2"
          />
          <img
            src={overlay3}
            alt="NIECCE early childhood education classroom"
            title="NIECCE early childhood education classroom"
            className="float-img img3"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default PioneersSection;
